/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class FantasticRgpd extends HTMLElement {
    constructor() {
      super();
      this.check = this.querySelector('#ff-check_legal');
      this.form = this.querySelector('form');
      this.button = this.querySelector('#ff-button-submit');
      this.error = this.querySelector('#ff-privacy-error');
      this.checkSubmit();
      this.checkChecked();
    }
  
    checkSubmit() {
      this.button && 
        this.button.addEventListener('click', (event) => {
          this.check.checked ? 
            this.error.classList.add('ff-hide-element')
          :
          (
            event.preventDefault(),
            this.error.classList.remove('ff-hide-element')
          )
        })
    }
    checkChecked() {
      this.check && 
        this.check.addEventListener('click', (event) => {
          this.check.checked ? 
            this.error.classList.add('ff-hide-element')
          :
            this.error.classList.remove('ff-hide-element')
        })
    }
  }
  
  customElements.define("ff-legal-acceptance", FantasticRgpd);